import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { AppGlobals } from "../app.globals";
import { GlobalSearchResultModel } from "../interfaces/entities/search";

@Injectable({
  providedIn: "root",
})
export class SearchService {
  constructor(private service: ApiBaseService) {}

  // showLoader is false: a typeahead must never flash the global loading overlay.
  async globalSearch(payLoad: Record<string, unknown>): Promise<GlobalSearchResultModel> {
    return this.service.httpRequest("SearchService/GlobalSearch", {
      ...payLoad,
      UserEmailAddress: AppGlobals.LoggedInUserData.email ?? "",
    }, true, false);
  }

  async searchSharePoint(payLoad: Record<string, unknown>): Promise<GlobalSearchResultModel> {
    return this.service.httpRequest("SearchService/SharePointSearch", {
      ...payLoad,
      UserEmailAddress: AppGlobals.LoggedInUserData.email ?? "",
    }, true, false);
  }
}
